function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdvance = function SvgAdvance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24042"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17913",
    d: "M12 6V4m0 2a2 2 0 0 0 0 4m0-4a2 2 0 0 1 0 4m-6 8a2 2 0 0 0 0-4m0 4a2 2 0 0 1 0-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 0 0 0-4m0 4a2 2 0 0 1 0-4m0 4v2m0-6V4",
    transform: "translate(-.5 .5)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  })));
};

export default SvgAdvance;